import * as React from 'react';
import { VatReportData } from 'store/vat/models';
import { TaxReportSubsectionDataResponse } from 'store/vat/models/vatReportData';
import { getRawNumberForCopy, useNumberFormat } from 'utils/numberFormat';
interface JerseyFormProps {
  data?: VatReportData;
  renderValueCell: (boxNumber: string) => void;
  finalTotals: boolean;
}
export const JerseyForm: React.FC<JerseyFormProps> = ({
  data,
  renderValueCell,
  finalTotals,
}) => {
  const { formatNumber } = useNumberFormat();
  React.useEffect(() => {
    const selectedSubsections: TaxReportSubsectionDataResponse[] | undefined =
      !finalTotals ? data?.subsections : data?.adjustedSubsections;
    if (data === undefined || data === null) return;

    const currencySignSpans = document.querySelectorAll('.currency-sign');

    currencySignSpans.forEach((currencySignSpan) => {
      if (data.currencySymbol !== null) {
        currencySignSpan.textContent = data.currencySymbol;
      }
    });

    data.sections?.forEach((section, i) => {
      const sectionNameCell = document.querySelector(`#section10${i}-name`);
      if (sectionNameCell) {
        sectionNameCell.textContent = section.name;
      }
    });

    selectedSubsections?.forEach((subsection) => {
      const boxNumber = subsection.code?.replace(/^Box\s+/, '').toLowerCase();

      const subsectionNameCell = document.getElementById(
        `subsection${boxNumber}-name`
      );
      const subsectionBoxNameCell = document.getElementById(
        `subsection${boxNumber}-box-name`
      );

      const subsectionValueSpan = document.getElementById(
        `subsection${boxNumber}-value-span`
      );

      if (
        subsectionBoxNameCell !== null &&
        subsectionNameCell !== null &&
        subsectionValueSpan !== null
      ) {
        subsectionNameCell.textContent = subsection.name;
        subsectionBoxNameCell.textContent = subsection.code;

        const textContent: any = subsection.net;
        subsectionValueSpan.textContent = formatNumber(textContent);
        subsectionValueSpan.setAttribute('data-raw-value', getRawNumberForCopy(textContent));
      }
    });
  }, [data, finalTotals, formatNumber]);

  return (
    <table className="vatreporttable table">
      <thead>
        <tr>
          <th id="section100-name">Vat Return</th>
          <th></th>
          <th style={{ width: 130, textAlign: 'center' }}>
            Value - <span className="currency-sign"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td id="subsection1-name">Total sales excluding GST</td>
          <td id="subsection1-box-name" className="box">
            Box 1
          </td>
          <td
            id="subsection1-value"
            className="rightalign value-field"
          >
            {renderValueCell('1')}
          </td>
        </tr>
        <tr>
          <td id="subsection2-name">
            Zero-rated goods or services, and any supplies to ISE's
          </td>
          <td id="subsection2-box-name" className="box">
            Box 2
          </td>
          <td
            id="subsection2-value"
            className="rightalign value-field"
          >
            {renderValueCell('2')}
          </td>
        </tr>
        <tr>
          <td id="subsection3-name">Total sales subject to GST</td>
          <td id="subsection3-box-name" className="box">
            Box 3
          </td>
          <td
            id="subsection3-value"
            className="rightalign value-field"
          >
            {renderValueCell('3')}
          </td>
        </tr>
        <tr>
          <td id="subsection4-name">
            Total purchases and expenses (excluding imports)
          </td>
          <td id="subsection4-box-name" className="box">
            Box 4
          </td>
          <td
            id="subsection4-value"
            className="rightalign value-field"
          >
            {renderValueCell('4')}
          </td>
        </tr>
        <tr>
          <td id="subsection5-name">Total value of imports</td>
          <td id="subsection5-box-name" className="box">
            Box 5
          </td>
          <td
            id="subsection5-value"
            className="rightalign value-field"
          >
            {renderValueCell('5')}
          </td>
        </tr>
        <tr>
          <td id="subsection6-name">GST on sales</td>
          <td id="subsection6-box-name" className="box">
            Box 6
          </td>
          <td
            id="subsection6-value"
            className="rightalign value-field"
          >
            {renderValueCell('6')}
          </td>
        </tr>
        <tr>
          <td id="subsection7-name">GST paid on boxes 4 & 5</td>
          <td id="subsection7-box-name" className="box">
            Box 7
          </td>
          <td
            id="subsection7-value"
            className="rightalign value-field"
          >
            {renderValueCell('7')}
          </td>
        </tr>
        <tr>
          <td id="subsection8-name">Total amount payable or refundable</td>
          <td id="subsection8-box-name" className="box">
            Box 8
          </td>
          <td
            id="subsection8-value"
            className="rightalign value-field"
          >
            {renderValueCell('8')}
          </td>
        </tr>
      </tbody>
    </table>
  );
};
